import React from "react"
import {
  useDisclosure,
  Heading,
  Button,
  Text,
  Flex,
  ModalCloseButton,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Modal,
} from "@chakra-ui/react"
import { Icon, IFrame } from "../.."

export default function Example({ heading }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button
        mt={{ base: 8, xl: "auto" }}
        onClick={onOpen}
        alignSelf="center"
        variant="primary"
        size="sm"
      >
        <Text as="span" lineHeight={1} fontSize="sm" fontWeight="bold">
          See an example
        </Text>
        <Icon name="arrowRight" boxSize={4} ml={3} />
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0,0,0,0.85)" />
        <ModalContent
          maxW={{
            base: "100%",
            md: "35rem",
            lg: "44rem",
            xl: "57rem",
            "2xl": "75rem",
          }}
          px={{ base: 4, md: 0 }}
          bg="transparent"
          w="100%"
        >
          <Flex direction="column" layerStyle="foreground" bg="base.d200">
            <ModalHeader position="relative" pr={14} bg="base.900">
              <Heading size="lg">{heading}</Heading>
              <ModalCloseButton transform="translateY(-50%)" top="50%" />
            </ModalHeader>

            <ModalBody position="relative" p={0} bg="base.d400">
              <IFrame link="https://paul-brown.vr-360-tour.com/e/OfYBebeno9s/e?fadetransition=true&hide_logo=true&hidelive=true&share_button=true" />
            </ModalBody>
          </Flex>
        </ModalContent>
      </Modal>
    </>
  )
}
